interface HeaderProps {
    headerTitle: string;
}

const Header: React.FC<HeaderProps> = ({ headerTitle }) => {
  return (
    <h1 className="text-2xl font-bold">{headerTitle}</h1>
  );
};

export default Header;
